import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const deleteUser = createAsyncThunk(
    'editUserForm/deleteUser',
    async ({userId, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/users/${userId}/delete`,
            {
                method: 'DELETE',
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        .then(response => response.json())
        return response;
    }
)

export const updateUser = createAsyncThunk(
    'editUserForm/updateUser',
    async ({userToUpdate, token}) => {
        const requestBody = JSON.stringify(userToUpdate);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/users/${userToUpdate.userId}/updateUser`,
            {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.json())
        return response;
    }
)

export const editUserFormSlice = createSlice({
    name: 'editUserForm',
    initialState: {
        userId: '',
        name: '',
        userRole: '',
        branch: '',
        active: false,
        updatingUser: false,
        failedToUpdateUser: false,
        confirmingUpdate: false,
        deletingUser: false,
        failedToDeleteUser: false,
        confirmingDelete: false,
        status: ''
    },
    reducers: {
        changeEditUserId: (state, action) => {
            return {
                ...state,
                userId: action.payload
            }
        },
        changeEditUserName: (state, action) => {
            return {
                ...state,
                name: action.payload
            }
        },
        changeEditUserRole: (state, action) => {
            return {
                ...state,
                userRole: action.payload
            }
        },
        changeEditUserBranch: (state, action) => {
            return {
                ...state,
                branch: action.payload
            }
        },
        toggleEditUserForm: (state) => {
            return {
                ...state,
                active: !state.active,
                status: ''
            }
        },
        clearEditUserForm: (state) => {
            return {
                ...state,
                name: '',
                userRole: '',
                branch: '',
                status: ''
            }
        },
        changeStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        },
        setConfirmingUserUpdate: (state, action) => {
            return {
                ...state,
                confirmingUpdate: action.payload
            }
        },
        setConfirmingUserDelete: (state, action) => {
            return {
                ...state,
                confirmingDelete: action.payload
            }
        }
    },
    extraReducers: {
        [deleteUser.pending]: (state) => {
            return {
                ...state,
                deletingUser: true,
                failedToDeleteUser: false
            }
        },
        [deleteUser.fulfilled]: (state) => {
            return {
                ...state,
                deletingUser: false,
                failedToDeleteUser: false
            }
        },
        [deleteUser.rejected]: (state) => {
            return {
                ...state,
                deletingUser: false,
                failedToDeleteUser: true
            }
        },
        [updateUser.pending]: (state) => {
            return {
                ...state,
                updatingUser: true,
                failedToUpdateUser: false
            }
        },
        [updateUser.fulfilled]: (state) => {
            return {
                ...state,
                updatingUser: false,
                failedToUpdateUser: false
            }
        },
        [updateUser.rejected]: (state) => {
            return {
                ...state,
                updatingUser: false,
                failedToUpdateUser: true
            }
        }
    }
})

export const selectEditUserFormUserId = (state) => state.editUserForm.userId;
export const selectEditUserFormName = (state) => state.editUserForm.name;
export const selectEditUserFormUserRole = (state) => state.editUserForm.userRole;
export const selectEditUserFormBranch = (state) => state.editUserForm.branch;
export const editUserFormIsActive = (state) => state.editUserForm.active;
export const editUserStatus = (state) => state.editUserForm.status;
export const selectConfirmingUserUpdate = (state) => state.editUserForm.confirmingUpdate;
export const userUpdating = (state) => state.editUserForm.updatingUser;
export const selectConfirmingUserDelete = (state) => state.editUserForm.confirmingDelete;
export const userDeleting = (state) => state.editUserForm.deletingUser;

export const { changeEditUserId, changeEditUserName, changeEditUserRole, changeEditUserBranch, toggleEditUserForm, clearEditUserForm, changeStatus, setConfirmingUserUpdate, setConfirmingUserDelete } = editUserFormSlice.actions;

export default editUserFormSlice.reducer;